export default {"src":"/planos/_next/static/media/score.191850ef.svg","height":177,"width":353,"blurWidth":0,"blurHeight":0};